exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "agm-map {\n  height: 150px !important;\n}\n\n.searchTextBox {\n  width: 500px !important;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/entities/details/addressinformation/addaddress/add-address.component.css
// module id = 1947
// module chunks = 0